<template>
  <div>
  <Card>
      <Row>
        <i-col :md="18" span="24">
          <Form ref="searchForm" inline :model="searchForm" :label-width="70" @submit.native.prevent>
            <FormItem label="Agent名称" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入Agent名称" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getAgentList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col :md="6" span="24" class="mob-align-right">
          <Button style="float: right;" @click="AddAgent" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加</Button>
        </i-col>
       </Row>
       <Row>
       <col span="10">
        <draggable v-model="trashZone" class="dropzone trashzone" :options="trashOptions">
          <div slot="footer" class="footer">
            <div class="del">
              <Icon :size="32" type="md-trash"></Icon>
            </div>
          </div>
        </draggable>
       </col>
       </Row>
      <Drawer
        title="添加"
        v-model="change"
        width="500"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="Agent名称" prop="name">
             <i-input  v-model="formItem.name" disabled placeholder="agent名称为填完版本号后自动生成,无需填写"></i-input>
          </form-item>
          <FormItem label="适用操作系统"  prop="os_type">
            <Select v-model="formItem.os_type" style="min-width:100px">
              <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <form-item label="版本号" prop="version">
             <i-input  v-model="formItem.version" placeholder="Agent版本号" @on-blur="handleAgentName"></i-input>
          </form-item>
          <form-item label="是否最新版本" prop="is_latest">
             <i-switch v-model="formItem.is_latest">
               <span slot="open">是</span>
               <span slot="close">否</span>
            </i-switch>
          </form-item>
          <form-item label="图片名称" prop="img">
             <i-input  v-model="formItem.img" placeholder="Agent显示的图片名称"></i-input>
          </form-item>
          <form-item label="描述" prop="description">
             <i-input  v-model="formItem.description" placeholder="请输入Agent描述"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>

       <Drawer
        title="Agent批量操作"
        v-model="changeAgent"
        width="780"
        :mask-closable="true"
        @on-close="drawerCloseAgent"
      >
      <i-form ref="formItemAgent" :model="formItemAgent" :label-width="0">
         <form-item>
          <RadioGroup v-model="rdOperateSel">
          <Radio label="install">
              <Icon type="md-hammer" />
              <span>安装</span>
          </Radio>
          <Radio label="update">
              <Icon type="md-arrow-round-up" />
              <span>升级</span>
          </Radio>
          <Radio label="uninstall">
              <Icon type="md-close" />
              <span>卸载</span>
          </Radio>
        </RadioGroup>
        </form-item>
        <form-item>
           <Button type="success" ghost @click="modalServer=true">选择主机</Button>
        </form-item>
        <form-item>
        <h4>已选择主机列表：</h4>
        <Table
            ref="table"
            size="small"
            :columns="columns"
            :data="tableData"
            :loading="table_loading"
          ></Table>
        </form-item>
        <form-item>
           <i-button type="primary" @click="handleExecute">开始执行</i-button>
           <i-button style="margin-left: 8px" @click="changeAgent=false">取消执行</i-button>
        </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
    <Card :bordered="false">
        <Row style="" class="idc-item-list">
        <draggable v-for="item in agentList" :key="item.id" @start="start" @end="end($event, item.id)">
        <i-col :key="item.id" span="24" class="dropitem">
          <div @click="handleAgentInstall(item)">
              <div class="idc-item" >
                  <div class="header">
                      <div class="name">
                          <h4>{{ item.name }}</h4>
                      </div>
                  </div>
                  <div class="img">
                      <img :src="item.img" />
                  </div>
              </div>
            </div>
        </i-col>
       </draggable>
      </Row>
       <Modal
        v-model="modalServer"
        width="850"
        title="主机选择"
        @on-ok="ok"
        @on-cancel="cancel">
        <ServerSelList @on-result-change="onResultChange" :rdOperateSel="rdOperateSel" :latestWinVersion="latestWinVersion" :latestLinuxVersion="latestLinuxVersion" ref="serverSelList" />
      </Modal>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import nginxPic from '@/assets/images/nginx.png'
import monitorPic from '@/assets/images/monitor.png'
import logPic from '@/assets/images/log.png'
import defaultPic from '@/assets/images/default.png'
import { getAgentList, saveAgent, installAgent, unInstallAgent, updateAgent, deleteAgent } from '@/api/opscenter'
import draggable from 'vuedraggable'
import ServerSelList from './ServerSelList'
export default {
  name: 'AgentList',
  components: {
    Tables,
    draggable,
    ServerSelList
  },
  data () {
    return {
      trashOptions: {
        group: {
          name: 'trash',
          draggable: '.dropitem',
          put: () => true,
          pull: false
        }
      },
      trashZone: [],
      searchForm: {
        name: null
      },
      rdOperateSel: 'install',
      modalServer: false,
      osList: [
        {
          value: '0',
          label: 'Linux'
        },
        {
          value: '1',
          label: 'Windows'
        }
      ],
      nginxPic: nginxPic,
      monitorPic: monitorPic,
      logPic: logPic,
      defaultPic: defaultPic,
      count: 0,
      size: 10,
      page: 1,
      latestWinVersion: '',
      latestLinuxVersion: '',
      agentSelectVersion: '',
      columns: [
        {
          minWidth: 100,
          title: '主机名',
          tooltip: true,
          key: 'hostname',
          align: 'center'
        },
        {
          minWidth: 100,
          title: '操作系统',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        {
          minWidth: 130,
          title: '私有IP',
          align: 'center',
          key: 'inner_ip'
        },
        {
          minWidth: 130,
          title: '公网IP',
          align: 'center',
          key: 'public_ip'
        },
        {
          minWidth: 120,
          title: '凭证',
          align: 'center',
          key: 'certificate',
          render: (h, params) => {
            if (params.row.certificate) {
              // 取凭证数组里面 is_admin 是true的名字
              let cerAdmin = params.row.certificate.filter(item => item.is_admin === true)
              if (cerAdmin.length > 0) {
                return h('div', cerAdmin[0].name)
              }
            } else {
              return ''
            }
          }
        },
        {
          minWidth: 120,
          title: 'Agent状态',
          align: 'center',
          key: 'status',
          render: (h, params) => {
            const row = params.row
            const color = row.status === 0 ? 'error' : row.status === 1 ? 'success' : 'warning'
            const text = row.status === 0 ? '断开' : row.status === 1 ? '运行' : '未知'
            // 未安装， 正常， 异常
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        }
      ],
      tableData: [],
      table_loading: false,
      change: false,
      changeAgent: false,
      agentList: [],
      changeLoadingShow: false,
      formItem: {
        name: '',
        os_type: '',
        version: '',
        is_latest: true,
        img: '',
        description: ''
      },
      formItemAgent: {
      },
      ruleValidate: {
        name: [{ required: true, message: 'Agent名称不能为空 !', trigger: 'blur' }],
        version: [{ required: true, message: 'Agent版本号不能为空 !', trigger: 'blur' }],
        os_type: [{ required: true, message: '操作系统不能为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleAgentName () {
      if (!this.formItem.os_type) {
        this.$Message.error('请先选择Agent对应的操作系统')
      } else {
        if (this.formItem.os_type === '0') {
          this.formItem.name = 'monitor-linux-' + this.formItem.version
        } else if (this.formItem.os_type === '1') {
          this.formItem.name = 'monitor-windows-' + this.formItem.version
        }
      }
    },
    onResultChange (val) {
      // this.tableData = val
    },
    handleExecute () {
      if (this.rdOperateSel === 'install') {
        this.handleSubmitInstall()
      } else if (this.rdOperateSel === 'update') {
        this.handleUpdate()
      } else if (this.rdOperateSel === 'uninstall') {
        this.handleDelete()
      }
    },
    handleUpdate () {
      if (this.tableData.length > 0) {
        this.changeLoadingShow = true
        let ids = this.tableData.map(item => item.id)
        let data = { 'ids': ids, 'version': this.agentSelectVersion }
        updateAgent(data).then(res => {
          if (res.data.code === 200) {
            this.changeAgent = false
            this.getAgentList()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行升级！'})
      }
      this.changeLoadingShow = false
    },
    handleDelete () {
      if (this.tableData.length > 0) {
        this.changeLoadingShow = true
        let ids = this.tableData.map(item => item.id)
        let data = { 'ids': ids, 'version': this.agentSelectVersion }
        unInstallAgent(data).then(res => {
          if (res.data.code === 200) {
            this.changeAgent = false
            this.getAgentList()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行卸载！'})
      }
      this.changeLoadingShow = false
    },
    handleSubmitInstall () {
      if (this.tableData.length > 0) {
        this.changeLoadingShow = true
        let ids = this.tableData.map(item => item.id)
        let data = { 'ids': ids, 'version': this.agentSelectVersion }
        installAgent(data).then(res => {
          if (res.data.code === 200) {
            this.changeAgent = false
            this.getAgentList()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行安装！'})
      }
      this.changeLoadingShow = false
    },
    ok () {
      this.tableData = this.$refs.serverSelList.tableDataSel
    },
    cancel () {
      this.$Message.info('Clicked cancel')
    },
    handleAgentInstall (item) {
      this.changeAgent = true
      this.tableData = []
      this.agentSelectVersion = item.version
      this.$refs.serverSelList.countSel = 0
      this.$refs.serverSelList.searchForm.os = parseInt(item.os_type)
      this.$refs.serverSelList.$refs.selection.selectAll(false)
      this.$refs.serverSelList.getServers()
    },
    getAgentList () {
      let params = {
        // search: this.searchForm.name
      }
      getAgentList(params).then(res => {
        this.latestWinVersion = res.data.filter(item => item.os_type === '1' && item.is_latest === true).map(m => m.version)[0]
        this.latestLinuxVersion = res.data.filter(item => item.os_type === '0' && item.is_latest === true).map(m => m.version)[0]
        this.agentList = res.data
        console.log(this.latestLinuxVersion)
        for (let i in this.agentList) {
          switch (this.agentList[i].img) {
            case 'nginx':
              this.agentList[i].img = this.nginxPic
              break
            case 'monitor':
              this.agentList[i].img = this.monitorPic
              break
            case 'log':
              this.agentList[i].img = this.logPic
              break
            default:
              this.agentList[i].img = this.defaultPic
          }
        }
      })
    },
    AddAgent () {
      let that = this.formItem
      this.change = true
      that.name = ''
      that.description = ''
    },
    drawerClose () {
      let that = this.formItem
      that.name = ''
      that.description = ''
    },
    drawerCloseAgent () {
    },
    searchReset () {
      // this.searchForm.name = null
    },
    handleSubmit (name) {
      // let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          saveAgent(this.formItem).then(res => {
            if (res.data.id > 0) {
              this.change = false
              this.getAgentList()
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    },
    start (event) {
      console.log('start', event)
    },
    end (event, value) {
      event.preventDefault()
      if (event.to.className === 'dropzone trashzone') {
        // 调用api接口删除Agent
        deleteAgent(value).then(res => {
          this.$Message.success('删除成功')
        })
      }
    }
  },
  mounted: function () {
    console.log('mount')
    this.getAgentList()
  }
}
</script>

<style lang="less">
  @import '../agent.less';

.dropzone {
  border: 1px dotted #ec4748;
  margin: .1rem;
  min-height: 95px;
  width: 100%;
  max-width: 372px;
  position: relative;
}

.trashzone .dropitem {
  display: none;
}

.trashzone .footer {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  padding-top: 2vh;
}

.trashzone .dropitem + .footer {
  background: #ec4748;
  color: white;
}

.trashzone .dropitem + .footer .del{
   background: rgba(255,255,255,.2);
}

.trashzone .dropitem + .footer ::after{
   color: #fff;
}

.del{
    background: #ec4748;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    text-align: center;
    margin-left: 56px;
    padding-top: 14px;
}
.del::after {
  content: '将Agent拖到此处删除';
  position: absolute;
  top: 30px;
  left: 60px;
  width: auto;
  margin-left: 68px;
  margin-top: 10px;
  color: #999;
  display: inline-block;
}
.del .ivu-icon{
  color:#fff;
}
</style>
